<template>
    <div v-html="displayValue"/>
</template>

<script>
export default {
    props: ['row'],
    computed: {
        displayValue() {
            if (this.row.ticket_min > 0) {
                return Vue.filter('money')(this.row.ticket_min / 100);
            }

            return '&mdash;';
        },
    },
};
</script>
